import { TPartnerFormData } from 'src/@types';
import { IPartner } from 'src/models';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';

const SUB_URL = '/v1/partner';

const convertDataInfoToFormData = (data: TPartnerFormData) => {
  const formData = new FormData();
  // 이미지 파일 추가
  if (data.logoImgPath) {
    formData.append('logoImgPath', data.logoImgPath);
  }

  // 새로 업로드된 파일 추가
  if (data.logoImgFile) {
    formData.append('logoImgFile', data.logoImgFile);
  }
  if (data.deleteLogoImgPath) {
    formData.append('deleteLogoImgPath', data.deleteLogoImgPath);
  }

  if (data.ordr) {
    formData.append('ordr', data.ordr.toString());
  }
  formData.append('partnerName', data.partnerName);
  formData.append('useYn', data.useYn ? 'true' : 'false');
  formData.append('partnerCtgyCd', data.partnerCtgyCd.toString());

  return formData;
};

/**
 *목록 조회
 */
export const getPartner = async () => {
  try {
    const url = SUB_URL;
    const response = await instance.get<TApiResponseData<IPartner[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
        pagination: response.data.pagination,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 상세 조회
 */
export const getDetail = async (partnerSid: number) => {
  try {
    const url = `${SUB_URL}/${partnerSid}`;
    const response = await instance.get<TApiResponseData<IPartner>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 파트너등록
 */
export const post = async (data: TPartnerFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);

    const response = await instance.post<TApiResponseData<IPartner>>(
      `${SUB_URL}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 파트너 수정
 */
export const put = async (partnerSid: number, data: TPartnerFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);

    const response = await instance.put<TApiResponseData<IPartner>>(
      `${SUB_URL}/${partnerSid}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 파트너 삭제
 */
export const remove = async (partnerSid: number) => {
  try {
    const url = `${SUB_URL}/${partnerSid.toString()}`;
    const response = await instance.delete<TApiResponseData<IPartner>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
